export enum ApiModifiableCodeEnum {
    System = 'S',
    Client = 'K',
}
